// The question bank shows answer keys with the correct option marked, so only
// question and exam staff may open it; a student only takes exams.
const QUESTION_BANK_PERMS =["create_question", "approve_question", "vote_question", "create_exam"];

// Which permissions open each page (any one of them), in the order "/" picks the home page from.
// The sidebar shows a page and the routes let one in by this table.
const PAGE_PERMS = {
  "/my-questions": ["create_question"],
  "/questions": QUESTION_BANK_PERMS,
  "/folders": QUESTION_BANK_PERMS,
  "/my-evaluations": ["vote_question"],
  "/evaluators": ["approve_question"],
  "/available-exams": ["take_exam"],
  "/my-attempts": ["view_own_results"],
  "/test_list": ["create_exam"],
  "/exams_list": ["create_exam"],
};

// Roles in exam subjects (my_account.folder_roles) open pages too, without any global permission: any role
// opens the bank, a role that writes questions opens My questions, a role that reviews them My evaluations.
const PAGE_FOLDER_ROLES = {
  "/my-questions": ["author", "moderator", "expert"],
  "/questions": ["moderator", "expert", "author", "viewer"],
  "/folders": ["moderator", "expert", "author", "viewer"],
  "/my-evaluations": ["expert", "moderator"],
  // Tasks are given in subjects only: whoever writes or reviews questions in one may have some.
  "/my-tasks": ["author", "expert", "moderator"],
};

// Pages only admins (my_account.role.code "ADMIN") open: the BTS booklets.
const ADMIN_PAGES = ["/bts"];

export const hasAnyPerm = (perms, required) =>
  Array.isArray(perms) && required.some((perm) => perms.includes(perm));

// `user` is my_account ({role, perms, folder_roles}).
export const canOpenPage = (user, path) =>
  ADMIN_PAGES.includes(path)
    ? user?.role?.code === "ADMIN"
    : hasAnyPerm(user?.perms, PAGE_PERMS[path] ?? []) || hasAnyPerm(user?.folder_roles, PAGE_FOLDER_ROLES[path] ?? []);

// The page "/" and unknown paths lead to.
export const getHomePage = (user) =>
  Object.keys(PAGE_PERMS).find((path) => canOpenPage(user, path)) ?? "/available-exams";
